import { createContext } from 'react'

export type PlatformRoleContextValue = {
  role: string | null | undefined
  isSiteAdmin: boolean
  isPlatformStaff: boolean
  canSeeClients: boolean
  isLoading: boolean
  isError: boolean
  error: Error | null
}

export const PlatformRoleContext = createContext<PlatformRoleContextValue | null>(null)
